import "../../../styles/stores/stockManagement/stockDetails.css";
import { AddDamagesUrl } from "../../../api/endpoints";
import { useState, useEffect } from "react";
import { ButtonLoader } from "../../../components/uxCollections/Loaders";
import { getAllData, saveData } from "../../../tools/indexdb";
import store from "../../../app/store";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";

const AddDamages = ({ closeModal, product, storeID, updateSelectedProduct, storeName }) => {
  const [noOfProductDamaged, setNoOfProductDamaged] = useState("");
  const [isDamagedAmountValid, setIsDamagedAmountValid] = useState(false);
  const [description, setDescription] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false); //

  useEffect(() => {
    if (noOfProductDamaged && parseInt(noOfProductDamaged) < product.quantity) {
      setIsDamagedAmountValid(true);
    } else {
      setIsDamagedAmountValid(false);
    }
  }, [noOfProductDamaged]);

  useEffect(() => {
    if (noOfProductDamaged && isDamagedAmountValid) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [noOfProductDamaged, description, isDamagedAmountValid]);

  const addDamages = async () => {
    setIsLoading(true);
    let accessToken = localStorage.getItem("accessToken");
    let addDamagesPayload = {
      productID: product._id,
      quantityDamaged: noOfProductDamaged,
      reasonForDamage: description ? description : "No description",
    };
    console.log(addDamagesPayload);
    try {
      let response = await fetch(AddDamagesUrl + storeID, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(addDamagesPayload),
      });
      if (response.ok) {
        uiAlert("Damages added successfully", "success");
        //refreshData();
        let { storeProductCollection, modifiedProduct } = await response.json();
        updateSelectedProduct(modifiedProduct);

        let storeData = await getAllData(storeName);
        if (storeData) {
          storeData.storeProductCollection = storeProductCollection.products;

          await saveData(storeName, storeData);
          closeModal(false);
          setIsLoading(false);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div onClick={() => closeModal(false)} className='addSalesWrapper2'>
        <div className='addSalesContainer' onClick={(e) => e.stopPropagation()}>
          <h4 style={{ textAlign: "center", marginBottom: "20px" }}>Add damages</h4>
          <p className='salesTagtitl3643'>Current damaged</p>
          <div className='oldPriceDIv32'>
            <p> {product.damagedAmount} </p>
            <p style={{ color: "blue", cursor: "pointer" }}>Recover</p>
          </div>
          <p className='salesTagtitl3643'> Number of product damgaed </p>
          <div className='oldPriceDIv32'>
            <input
              value={noOfProductDamaged}
              onChange={(e) => setNoOfProductDamaged(e.target.value)}
              className='salesPriceIn34'
              type='number'
              placeholder='Enter number of product damaged'
            />
          </div>
          {noOfProductDamaged && !isDamagedAmountValid && <span> Damaged amount should be lower than available quantity </span>}
          <p className='salesTagtitl3643'> Describe how damage occured. </p>

          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            maxLength={80}
            cols={4}
            rows={3}
            className='salesPriceIn341'
            type='number'
            placeholder='describe how product got damaged.(optional) '
          />

          {isFormValid ? (
            isLoading ? (
              <div className='addSalesbtnDiv343'>
                <button disabled style={{ cursor: "not-allowed", opacity: "0.7", backgroundColor: "#4c5370" }} className='addSalesBtn234'>
                  {" "}
                  <ButtonLoader />
                </button>
              </div>
            ) : (
              <div className='addSalesbtnDiv343'>
                <button onClick={addDamages} className='addSalesBtn234'>
                  {" "}
                  Confirm damages
                </button>
              </div>
            )
          ) : (
            <div className='addSalesbtnDiv343'>
              <button disabled style={{ cursor: "not-allowed", opacity: "0.7", backgroundColor: "#4c5370" }} className='addSalesBtn234'>
                {" "}
                Confirm damages
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddDamages;
